import type { InvestmentState } from "@/domain/investment/types";

export type InvestmentBadgeVariant = "secondary" | "success" | "warning" | "info" | "destructive";

export const INVESTMENT_STATE_VARIANT: Record<InvestmentState, InvestmentBadgeVariant> = {
  prospect: "secondary",
  reserved: "warning",
  financing: "info",
  funded: "success",
  declared: "secondary",
  cancelled: "destructive",
  expired: "destructive",
  rejected: "destructive",
};

export const INVESTMENT_STATE_BAR: Record<InvestmentState, string> = {
  prospect: "bg-muted-foreground",
  reserved: "bg-warning",
  financing: "bg-info",
  funded: "bg-success",
  declared: "bg-brand-lavender",
  cancelled: "bg-destructive",
  expired: "bg-destructive",
  rejected: "bg-destructive",
};
